"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const components_1 = require("@alcumus/components");
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const icons_1 = require("@material-ui/icons");
const recoil_1 = require("recoil");
const CreateFolderModal_1 = require("../FoldersPage/CreateFolderModal");
const CreateDashboardModal_1 = require("../Modals/CreateDashboardModal");
const CreateLookModal_1 = require("../Modals/CreateLookModal");
const useStyles = (0, core_1.makeStyles)((theme) => ({
    buttonBase: {
        borderRadius: 100,
        padding: (props) => props.size === 'sm' ? '6px 12px 6px 16px' : '8px 20px 8px 24px',
    },
    buttonText: {
        fontWeight: components_1.StyleVariables.fonts.weight.semiBold,
        lineHeight: (props) => props.size === 'sm'
            ? components_1.StyleVariables.fonts.lineHeight.h6
            : components_1.StyleVariables.fonts.lineHeight.h5,
        fontSize: (props) => (props.size === 'sm' ? 14 : 16),
    },
    endIcon: {
        color: components_1.StyleVariables.colors.white,
        marginLeft: theme.spacing(1),
    },
    root: {
        marginTop: 4,
    },
    paper: {
        boxShadow: `0 2px 8px ${components_1.StyleVariables.colors.boxShadowGrey}`,
        borderRadius: theme.spacing(1),
        border: `1px solid ${components_1.StyleVariables.colors.border.default}`,
        width: (props) => (props.size === 'sm' ? 155 : 170),
    },
    menuItem: {},
    menuIcon: {
        marginRight: theme.spacing(1),
        color: components_1.StyleVariables.colors.grey4,
    },
}));
function CreateNewButton({ buttonSize }) {
    const classes = useStyles({ size: buttonSize });
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const open = Boolean(anchorEl);
    const { t } = (0, react_i18next_1.useTranslation)(['translation', 'AriaLabels']);
    const setCreateFolderModalVisibility = (0, recoil_1.useSetRecoilState)(CreateFolderModal_1.createFolderModalVisibleState);
    const setCreateDashboardModalVisibility = (0, recoil_1.useSetRecoilState)(CreateDashboardModal_1.createDashboardModalVisibleState);
    const setCreateLookModalVisibleState = (0, recoil_1.useSetRecoilState)(CreateLookModal_1.createLookModalVisibleState);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleFolderClick = () => {
        setAnchorEl(null);
        setCreateFolderModalVisibility(true);
    };
    const handleDashboardClick = () => {
        setAnchorEl(null);
        setCreateDashboardModalVisibility(true);
    };
    const handleLookClick = () => {
        setAnchorEl(null);
        setCreateLookModalVisibleState(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.Button, { "aria-label": t('createNew', { ns: 'AriaLabels' }), uppercase: false, rounded: true, className: classes.buttonBase, size: buttonSize === 'sm' ? 'small' : 'medium', onClick: (e) => handleClick(e), "data-testid": "createNewButton" },
            react_1.default.createElement(components_1.Text, { as: "h5", center: true, className: classes.buttonText }, t('createNewButton', { ns: 'translation' })),
            react_1.default.createElement(icons_1.ExpandMore, { className: classes.endIcon })),
        react_1.default.createElement(core_1.Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, className: classes.root, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, PopoverClasses: {
                paper: classes.paper,
            }, getContentAnchorEl: null },
            react_1.default.createElement(core_1.MenuItem, { onClick: handleFolderClick, className: classes.menuItem, "data-testid": "createFolder" },
                react_1.default.createElement(icons_1.FolderOutlined, { className: classes.menuIcon }),
                t('folder', { ns: 'translation' })),
            react_1.default.createElement(core_1.MenuItem, { onClick: handleDashboardClick, className: classes.menuItem, "data-testid": "createDashboard" },
                react_1.default.createElement(icons_1.DashboardOutlined, { className: classes.menuIcon }),
                t('dashboard', { ns: 'translation' })),
            react_1.default.createElement(core_1.MenuItem, { onClick: handleLookClick, className: classes.menuItem, "data-testid": "createLook" },
                react_1.default.createElement(icons_1.AssessmentOutlined, { className: classes.menuIcon }),
                t('look', { ns: 'translation' })))));
}
exports.default = CreateNewButton;
